import React, { createContext, useReducer } from "react";
import { useNavigate } from "react-router-dom";
import * as Context from "../";
import { fetchRequest } from "../fetch";
import { URLS } from "../../utils";

const initialState = {
  islogin: !!JSON.parse(localStorage.getItem("auth")),
  _auth: JSON.parse(localStorage.getItem("auth")),
  lang: "mn",
  errorMsg: "",
  basket: [],
  collect: {},
};

const models = {};
export const GlobalContext = createContext(initialState);

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(Context.appReducer, initialState);

  const addmodel = ({ model }) => {
    models[model] = {
      request: `request_${model}`,
      response: `response_${model}`,
      error: `error_${model}`,
    };
  };

  const navigate = useNavigate();

  const request = async ({
    url,
    model,
    body,
    method = "GET",
    isfile,
    mode = "main",
  }) => {
    try {
      if (isfile && body) {
        let formData = new FormData();
        Object.keys(body).map((keyname) => {
          formData.append(keyname, body[keyname]);
          return null;
        });
        body = formData;
      }

      if (model) {
        addmodel({ model: model });
      }
      const res = await fetchRequest({
        url: `${URLS[mode]}${url}`,
        method,
        body,
        mode,
        model: model ? models[model] : null,
        dispatchEvent: dispatch,
        isfile: isfile,
      });

      if (res.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("access_token");
        setlogin(false);
        navigate("/");
      }
      /* notification: notification, */
      return res;
    } catch (error) {}
  };

  const setlogin = (login) => dispatch({ type: "login", response: login });

  const setData = ({ data, model }) =>
    dispatch({ type: model, response: data });

  const setAuth = (data) => dispatch({ type: "auth", response: data });
  const setCollect = (data) => dispatch({ type: "collect", response: data });
  return (
    <React.Fragment>
      <GlobalContext.Provider
        value={{
          ...state,
          request,
          setlogin,
          setData,
          setAuth,
          setCollect,
        }}
      >
        {props.children}
      </GlobalContext.Provider>
    </React.Fragment>
  );
};
